@if (dataSet$ | async; as dataSet) {
<rs-sub-header>
  {{ 'BATCH' | translate }}
</rs-sub-header>

<rs-container #expandableArea>
  <ct-actions>
    <button
      data-testid="btn-bulk-excel"
      mat-button
      type="button"
      (click)="openDialog()"
      class="rs-btn--primary"
      [matTooltip]="'IMPORT' | translate"
    >
      <mat-icon fontIcon="add" />
      {{ 'IMPORT' | translate }}
    </button>

  </ct-actions>

  <renta-table-columns-reorderer
    (columnsStateModified)="tableColumns.set($event)"
    [tableColumns]="tableColumns()"
    [expandableArea]="expandableArea"
    [headerLabel]="('COLUMNS_TO_DISPLAY' | translate) || 'Loading translation'"
    localStorageKey="ord-admin-batch-table-columns"
  >
    <mat-table
      data-testid="ord-administration-batch-table"
      [dataSource]="dataSet.matTableDatasource"
    >
      @for (column of tableColumns(); track column) {
      <ng-container [matColumnDef]="column">
        <mat-header-cell *matHeaderCellDef>
          @if (column !== 'ACTIONS') {
          {{ column | translate }}
          }
        </mat-header-cell>

        <mat-cell
          *rsMatCellDef="let element; dataSource: dataSet.matTableDatasource"
          [attr.rs-table-responsive-header]="column | translate"
        >
          @switch (column) {
          @case ('FILE') {
          <ct-file>
            @if (element.requestFileName) {
            <button
              (click)="downloadInputFile(element.id, rsButtonSpinnerDirective)"
              mat-icon-button
              #rsButtonSpinnerDirective="rsButtonSpinner"
              rsButtonSpinner
              [attr.data-testid]="'btn-download-file-' + element.id"
            >
              <mat-icon
                rs-icon-outline
                fontIcon="file_download"
              />
            </button>
            }
            {{ element.requestFileName | rsNullDash }}
          </ct-file>
          }
          @case ('DATE') {
          {{ element.received | date:'short':'': translateService.currentLang | rsNullDash }}
          }
          @case ('STATUS') {
          <span [class]="element.status | statusChipClass">
            {{ element.status | uppercase | translate }}
          </span>
          }
          @case ('RESULT_FILE') {
          <ct-result-file>
            @if (element.resultFileName) {
            <button
              (click)="downloadResultFile(element.id, rsButtonSpinnerDirective)"
              mat-icon-button
              #rsButtonSpinnerDirective="rsButtonSpinner"
              rsButtonSpinner
              [attr.data-testid]="'btn-download-result-file-' + element.id"
            >
              <mat-icon
                rs-icon-outline
                fontIcon="file_download"
              />
            </button>
            }
            {{ element.resultFileName | rsNullDash }}
          </ct-result-file>
          }
          @case ('ACTIONS') {
          <button
            [disabled]="!element.canCancel"
            [attr.data-testid]="'btn-cancel-process-' + element.id"
            [matTooltip]="'CANCEL_PROCESS' | translate"
            (click)="openConfirmDialog(element.id)"
            type="button"
            mat-icon-button
          >
            <mat-icon fontIcon="close" />
          </button>
          }
          }
        </mat-cell>
      </ng-container>
      }

      <mat-header-row *matHeaderRowDef="tableColumns(); sticky: true" />

      <mat-row *matRowDef="let row; columns: tableColumns();" />

    </mat-table>

    <mat-paginator
      (page)="handlePageEvent($event)"
      [length]="dataSet.totalResults"
      [pageIndex]="paginationParams._page! - 1"
      [pageSize]="paginationParams._pageSize"
      [pageSizeOptions]="[5, 10, 15]"
      showFirstLastButtons="true"
    />

  </renta-table-columns-reorderer>
</rs-container>
}